<template>
    <q-dialog
        v-model="showAux"
        full-width
        content-class="classes-select"
        @input="hideClasses"
    >
        <q-card>
            <q-card-section class="row q-col-gutter-lg justify-center">
                <div class="col-12">
                    <h4>
                        {{ $t('courses.select_classes') }}
                    </h4>
                </div>
                <div class="col-12">
                    <q-list v-if="classes.length" class="text-left" separator>
                        <q-item
                            v-for="(item, index) in classes"
                            :key="index"
                            tag="label"
                        >
                            <q-item-section avatar top>
                                <q-radio
                                    v-model="preferredCourseId"
                                    :val="item.id"
                                    name="course"
                                />
                            </q-item-section>
                            <q-item-section>
                                <q-item-label>
                                    <div class="row q-col-gutter-md">
                                        <div class="col-4">
                                            <span
                                                class="caption text-grey text-capitalize"
                                                >{{ $t('general.code') }}
                                            </span>
                                            <br />
                                            <span class="body-1"
                                                >{{ item.code }}
                                            </span>
                                        </div>
                                        <div class="col-4">
                                            <span
                                                class="caption text-grey text-capitalize"
                                                >{{
                                                    $t(
                                                        'general.training_center'
                                                    )
                                                }}
                                            </span>
                                            <br />
                                            <span class="body-1"
                                                >{{ item.businessunits.name }}
                                            </span>
                                        </div>
                                        <div class="col-4">
                                            <span
                                                class="caption text-grey text-capitalize"
                                                >{{
                                                    $t(
                                                        'general.enrolls_available'
                                                    )
                                                }}
                                                / {{ $t('general.vacancies') }}
                                            </span>
                                            <br />
                                            <span class="body-1"
                                                >{{
                                                    item.vacancies -
                                                    item.trainee_number
                                                }}
                                                /
                                                {{ item.vacancies }}
                                            </span>
                                        </div>
                                        <div class="col-4">
                                            <span
                                                class="caption text-grey text-capitalize"
                                                >{{ $t('general.start_date') }}
                                            </span>
                                            <br />
                                            <span class="body-1"
                                                >{{
                                                    formatDate(item.start_date)
                                                }}
                                            </span>
                                        </div>
                                        <div class="col-4">
                                            <span
                                                class="caption text-grey text-capitalize"
                                                >{{
                                                    $t('general.end_date')
                                                }}</span
                                            >
                                            <br />
                                            <span class="body-1"
                                                >{{ formatDate(item.end_date) }}
                                            </span>
                                        </div>
                                        <div class="col-4">
                                            <span
                                                class="caption text-grey text-capitalize"
                                                >{{
                                                    $t('general.trainers')
                                                }}</span
                                            >
                                            <br />
                                            <span class="body-1"
                                                >{{
                                                    getTrainers(item.trainers)
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-list>
                    <p v-else>{{ $t('courses.no_classes_scheduled') }}</p>
                </div>
                <div class="col-12">
                    <q-btn
                        v-if="classes.length"
                        class="dialog-btn"
                        color="primary"
                        :class="{ disabled: !preferredCourseId }"
                        :disable="!preferredCourseId"
                        @click="addToCart"
                    >
                        <span> {{ $t('courses.proceed_purchase') }} </span>
                    </q-btn>
                    <q-btn
                        v-else
                        class="dialog-btn"
                        color="primary"
                        @click="addToCart"
                    >
                        <span> {{ $t('courses.proceed_purchase') }} </span>
                    </q-btn>
                </div>
            </q-card-section>
            <q-inner-loading :showing="isFetchingClasses">
                <q-spinner-pie color="primary" size="40px" />
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<script>
import notify from '@/local-shared/mixins/notify'
import classesService from '@/services/modules/classes'
import trainersService from '@/services/modules/trainers'
import moment from 'moment'
import store from '@/store'
import _ from 'lodash'

const loadingKeys = {
    fetchingClasses: 'fetching-classes',
}

export default {
    name: 'CourseClasses',

    mixins: [notify],

    props: {
        show: {
            type: Boolean,
            default: false,
        },

        course: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            showAux: false,
            courseAux: this.course,

            classes: [],
            preferredCourseId: null,
        }
    },

    computed: {
        isFetchingClasses() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingClasses
            ).length
        },

        locale() {
            return store.getters['locale/currentLocale']
        },
    },

    watch: {
        show(value) {
            this.showAux = value
            if (value === true) {
                this.fetchClasses()
            }
        },
    },

    created() {
        this.courseAux.preferred_class_id = null
    },

    methods: {
        dateMaskFormat() {
            return this.locale &&
                this.locale.definition &&
                this.locale.definition.dateFormat
                ? this.locale.definition.dateFormat
                : 'DD/MM/YYYY'
        },

        formatDate(date) {
            return date
                ? moment(String(date)).format(this.dateMaskFormat())
                : null
        },

        getTrainers(trainers) {
            return trainers
                ? _.uniqBy(trainers, 'user.id')
                      .map((trainer) => trainer.user.first_name)
                      .join(' | ')
                : ''
        },

        async getClassesTrainers() {
            for (let i = 0; i < this.classes.length; i++) {
                let response = await trainersService.trainersOnClass({
                    filter: {
                        classId: this.classes[i].id,
                    },
                })
                if (response.status === 200) {
                    this.classes[i].trainers = response.data.results
                } else {
                    this.classes[i].trainers = []
                }
            }
        },

        async fetchClasses() {
            this.loadingAdd(loadingKeys.fetchingClasses)

            let parameters = {
                filter: {
                    courseId: this.course.id,
                    dateRange: {
                        classes_start_date: {
                            begin:
                                moment(new Date())
                                    .add(1, 'days')
                                    .format('YYYY-MM-DD') + 'T00:00:00',
                        },
                    },
                    statusSlug: 'Aberto',
                },
                orderBy: [
                    {
                        column: 'start_date',
                        direction: 'asc',
                    },
                ],
                relations: {
                    status: true,
                    businessunits: true,
                    countActiveEnrollments: true,
                    //lessons: true,
                },
            }

            let response = await classesService.retrieve(parameters)

            if (response.status === 200) {
                this.classes = response.data.results
                await this.getClassesTrainers()
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }

            this.loadingRemove(loadingKeys.fetchingClasses)
        },

        hideClasses() {
            this.$emit('hide-classes')
        },

        addToCart() {
            this.courseAux.preferred_class_id = this.preferredCourseId
            this.$store.commit('cart/addItemToCart', this.courseAux)
            this.$emit('added')
            this.hideClasses()
        },
    },
}
</script>
